const state = {
  appId: '',
  userInfo: {}, //用户信息
  menuData: [],
  productData: [],
  curProduct: {}, // 当前选中产品
  iframeRouteArr: [], // 通过iframe渲染的路由
  defaultSystemId: '', // 默认系统id,刚登陆时保存进来
  tenetUserList: [], //用户多租户列表
  currentTenetId: '',
  currentSystemId: '',
  tabData: {
    fullPathList: [],
    pages: [],
    activeKey: ''
  },
  currentMenu: '', // 排除
  formUrl:'',
};

const mutations = {
  setCurrentTenetId(state, data) {
    state.currentTenetId = data
  },
  setTenetUserList(state, data) {
    state.tenetUserList = data
  },
  setAppId(state, data) {
    state.appId = data;
  },
  setUserInfo(state, data) {
    state.userInfo = data;
  },
  setMenuData(state, menuData) {
    state.menuData = menuData;
  },
  setTabData(state, data) {
    state.tabData = data;
  },
  setProductData(state, data) {
    state.productData = data;
  },
  setCurProduct(state, data) {
    state.curProduct = data;
  },
  iframeRouteArr(state, data) {
    state.iframeRouteArr = data
  },
  setCurrentMenu(state, data) {
    state.currentMenu = data
  },
  setCurrentSystemId(state, data) {
    state.currentSystemId = data
  },
  setFormUrl(state, data) {
    state.formUrl = data || ''
  }
  
};
export default {
  state,
  mutations
};
